import { Button } from 'components/universal/button';
import { useTopic } from 'hooks/useTopic';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCanSubmitAnswer } from 'store/topic/topicSlice';
import { TopicStatus } from '../topic-status';
import cls from './topic-status-with-button.module.scss';

export const TopicStatusWithButton: FC = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'components.topicStatusWithButton',
    });
    const {
        checkAnswers,
        isQuestionDone,
        isSuccessSendAnswer,
        totalPoints,
        obtainedPoints,
        handleTryAgainTask,
    } = useTopic();

    const canSubmitAnswer = useSelector(selectCanSubmitAnswer);
    
    return (
        <Fragment>
            {isSuccessSendAnswer ? (
                <TopicStatus
                    title={isQuestionDone ? t('titleDone') : t('titleNotDone')}
                    buttonText={t('buttonReset')}
                    obtainedPoints={obtainedPoints}
                    maxScore={totalPoints}
                    isSuccess={isQuestionDone}
                    onSubmit={
                        handleTryAgainTask
                    }
                />
            ) : (
                <Button
                    className={cls.button}
                    onClick={checkAnswers}
                    disabled={!canSubmitAnswer}
                >
                    {t('checkAnswerButtonText')}
                </Button>
            )}
        </Fragment>
    );
};
